import { render, staticRenderFns } from "./DistributorIcon.vue?vue&type=template&id=a6a74b72&scoped=true"
import script from "./DistributorIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributorIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DistributorIcon.vue?vue&type=style&index=0&id=a6a74b72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a74b72",
  null
  
)

export default component.exports